import React, { Component } from 'react';
import Icon from '../../2/Controls/Icon';

class WidgetTotalExpenses extends Component {

    constructor({ stores, fromDate, toDate , widget}) {
        super();
        this.state = {
            total_expenses: 0,
            stores: stores,
            fromDate: fromDate,
            toDate: toDate,
            widget:widget
        }
    }

    async componentDidMount() {
        this.loadData(this.state.stores, this.state.fromDate, this.state.toDate);
    }

    loadData(stores, fromDate, toDate) {
        this.props.getExpensesforSalesDashboard(this.props.user.user.RegistrationID, stores, "",
            fromDate, toDate)
            .then((result) => {
                this.setState({ total_expenses: result.searchResult.total_expenses })
            });
    }

    componentWillReceiveProps({ stores, fromDate, toDate }) {
        this.loadData(stores, fromDate, toDate);
    }

    render(){
        return <div className="info-box info-green" >
        <div className="info-box-icon ">
            <Icon type="expense"/>
        </div>
        <div className="info-box-content">
            <div className="info-box-text" >{this.state.widget && this.state.widget.hasOwnProperty('Title') && this.state.widget.Title.trim()!=="" ? this.state.widget.Title : "Expenses"}</div>
            <div className="info-box-number">{this.state.total_expenses}</div>
        </div>
    </div>
    }
    // render() {
    //     return <div className="col-md-3 col-sm-6 col-xs-12">
    //         <div className="info-box" style={{ marginTop: "10px" }}>
    //             <span className="info-box-icon " style={{backgroundColor:this.state.widget && this.state.widget.hasOwnProperty('WidgetOptionLeftBlockColor') && this.state.widget.WidgetOptionLeftBlockColor.trim()!=="" ? this.state.widget.WidgetOptionLeftBlockColor : "#00a65a"}}>
    //             <i style={{color:"white"}} className={this.state.widget && this.state.widget.hasOwnProperty('WidgetOptionLeftBlockIcon') && this.state.widget.WidgetOptionLeftBlockIcon.trim()!=="" ? this.state.widget.WidgetOptionLeftBlockIcon : "fa fa-cart-plus"} ></i></span>
    //             <div className="info-box-content">
    //                 <span className="info-box-text" style={{ fontSize: "13px" }}>{this.state.widget && this.state.widget.hasOwnProperty('Title') && this.state.widget.Title.trim()!=="" ? this.state.widget.Title : "Expenses"}</span>
    //                 <span className="info-box-number">{Number(this.state.total_expenses).toFixed(0)}</span>
    //             </div>
    //         </div>
    //     </div>
    // }
}

export default WidgetTotalExpenses